<template>
  <div>
    <list
      row-key="CostId"
      ref="list"
      unit="费用名称"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="showQuery"
      :get-data-func="api.list"
       v-if="trendShow"
       :temp-params="tempParams"
      urlHash="basedata/finance/expenseitems"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      
      <template slot="table">
       
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";


export default {
  mixins: [listMixin],
  components: { list },
  props: {
    IsSelect: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      api: require("@/api/ba/item").default,
      params: {
        ItemType: 1,
        ItemName: "",
        Status: null,
      },
      tempParams: {
        ItemType: 1
      },
      trendShow: true,
    };
  },
  mounted(){
     
  },
  methods: {
    onExport() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      let queryParams = this.$refs.list.queryParams;
      queryParams.ItemType = 1
      this.api.export(queryParams).then(() => {
        loading.close();
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>